import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, Renderer2 } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { ApiService } from '../api.service';
import Swal from 'sweetalert2';

@Component({
	selector: 'tables',
	templateUrl: './tables.component.html',
	styleUrls: ['./tables.component.scss']
})

export class TablesComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {

	@Input() courseID = 0
	@Input() parentType = 'lesson'
	@Input() parentID = 0
	lessonID = 0

	loading = true
	hasTables = false
	
	tables: any[] = []

	getLessonTablesSub = new Subscription
	editTableSub = new Subscription
	deleteTableSub = new Subscription

	@Output() onClose: EventEmitter<boolean> = new EventEmitter

	constructor(private dataService: ApiService, private renderer: Renderer2, private sanitizer: DomSanitizer) {}

	ngOnInit(): void {}

	ngAfterViewInit(): void {}

	ngOnChanges(): void {
		if (this.parentType == 'lesson') {
			this.lessonID = this.parentID
			this.getLessonTables(this.lessonID)
		}
	}

	ngOnDestroy(): void {
		this.getLessonTablesSub?.unsubscribe()
		this.editTableSub?.unsubscribe()
		this.deleteTableSub?.unsubscribe()
	}

	close() {
		this.onClose.emit(true)
	}

	getLessonTables(lesson: number) {
		this.getLessonTablesSub = this.dataService.getTables(lesson)
		.subscribe(
			(data: any) => {
				// console.log(data)
				this.tables = data
				this.hasTables = this.tables.length > 0
				// console.log(this.tables)

				this.tables.forEach((table: any) => {
					table.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(table.url) // URL
				})
			},
			(error: any) => {
				console.log(error)
				this.tables = []
				this.hasTables = false
			},
		)
	}

	copyTableHtml(table: any, event: Event) {
		// console.log(table)
		let clipboard = navigator.clipboard
		if (clipboard == undefined) return false
		
		navigator.clipboard.writeText(table.html)
		
		let link = event.currentTarget as HTMLLinkElement
		let span = link.nextElementSibling as HTMLSpanElement
		this.renderer.addClass(link, 'd-none')
		this.renderer.removeClass(span, 'd-none')
		setTimeout(() => {
			this.renderer.removeClass(link, 'd-none')
			this.renderer.addClass(span, 'd-none')
		}, 1500)

		return false
	}

	deleteTable(_id: number, _lesson: number) {
		// console.log(id)
		// console.log(lesson)

		Swal.fire({
			title: '¿Seguro?', 
			text: '¿Está seguro que desea eliminar esta tabla?', 
			icon: 'question',
			showCancelButton: true,
			cancelButtonText: 'Cancelar'
		}).then((result) => {
			// console.log(result)
			if (!result.isConfirmed) return
			
			/*
			this.deleteMultimediaItemSub = this.dataService.deleteMultimediaItem(id)
			.subscribe(
				(data: any) => {
					console.log(data)
					this.getLessonMultimedia(lesson)
				},
				(error: any) => {
					console.log(error)
				},
			)
			*/
		})

		return false
	}
}
